import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDesktopTier } from '../../hooks/useDesktopTier';
import { CircularProgress, Box } from '@mui/material';

interface LimitedModeRouteProps {
  children: React.ReactNode;
  restricted?: boolean; // If true, redirect desktop tier users to limited mode
}

/**
 * Route protection component that redirects desktop tier users from restricted routes
 * to the limited mode view
 */
const LimitedModeRoute: React.FC<LimitedModeRouteProps> = ({ 
  children, 
  restricted = false 
}) => {
  const { isDesktopTier, loading } = useDesktopTier();
  const location = useLocation();

  // Show loading state while checking subscription tier
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If route is restricted and user has desktop tier, redirect to limited mode
  if (restricted && isDesktopTier) {
    return <Navigate to="/" replace state={{ from: location.pathname, restricted: true }} />;
  }

  // Allow access for non-desktop tier users or non-restricted routes
  return <>{children}</>;
};

export default LimitedModeRoute;

